import { SectionShell } from "@/components/design-system/SectionShell";
import { Progress } from "@/components/ui/progress";

const code = `import { Progress } from "@/components/ui/progress";

<Progress
  value={62}
  max={100}
  label="Bottles towards the 100-bottle minimum"
  valueText="62 of 100 bottles"
/>`;

export function ProgressSection() {
  return (
    <SectionShell
      id="progress"
      title="Progress"
      description={
        <>
          A hairline track with a gold fill, for progress towards a target such
          as the 100-bottle minimum. Exposes <code>role=&quot;progressbar&quot;</code>{" "}
          with <code>aria-valuenow</code>, <code>aria-valuemax</code> and an
          optional <code>aria-valuetext</code>. Pair it with a line of copy — the
          bar never carries meaning on its own.
        </>
      }
      whenToUse={
        <ul>
          <li>Showing how close a selection is to the minimum order.</li>
        </ul>
      }
      whenNotToUse={
        <ul>
          <li>Indeterminate loading — this bar always has a known value.</li>
        </ul>
      }
      preview={
        <div className="grid gap-8 md:grid-cols-2">
          <div className="flex flex-col gap-6 bg-charcoal p-6">
            <div>
              <div className="field-label">md · 62 of 100</div>
              <Progress value={62} label="Example progress, 62 of 100" valueText="62 of 100 bottles" />
            </div>
            <div>
              <div className="field-label">md · 100 of 100</div>
              <Progress value={120} label="Example progress, complete" valueText="Minimum reached" />
            </div>
          </div>
          <div className="flex flex-col gap-6 bg-page p-6">
            <div>
              <div className="field-label">sm · 25 of 100</div>
              <Progress size="sm" value={25} label="Example progress, 25 of 100" />
            </div>
            <div>
              <div className="field-label">md · 0 of 100</div>
              <Progress value={0} label="Example progress, empty" />
            </div>
          </div>
        </div>
      }
      code={code}
      options={
        <ul className="list-disc pl-5">
          <li><code>value</code> — required; clamped to 0…<code>max</code>, so an over-target value shows a full bar.</li>
          <li><code>max</code> — default 100.</li>
          <li><code>label</code> — required accessible name; <code>valueText</code> — optional spoken reading.</li>
          <li><code>size</code>: <code>sm</code> (1px hairline) | <code>md</code> (3px, default).</li>
        </ul>
      }
    />
  );
}
